module.exports = __webpack_public_path__ + "static/img/street-icon.4281b82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/street-icon.png
// module id = a7qF
// module chunks = 0